import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Space,
  Table,
  Tag,
  Tooltip,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { blue, redPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup'
import { ASSIGNEE_TYPE } from '../../../constants'
import { SelectList } from '../../ConnectedDocumentOutgoingDocCreatePage/ConnectedDocumentOutgoingDocCreatePageStyled'

const InternalAssessmentUpdate = props => {
  const {
    open,
    setOpen,
    code,
    evaluatorType,
    ratingDetails,
    internalAssessmentStore,
    loadingAnimationStore,
    getRatingDetails,
    selectPeopleStore,
    authenticationStore,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    originDepartmentWithUserList,
  } = selectPeopleStore
  const {
    updateEvaluationDetail,
    updateStatus,
    updateAssignUser,
    updateRating,
  } = internalAssessmentStore
  const { currentUser } = authenticationStore
  const [form] = Form.useForm()
  const EDITOR_REF = useRef()
  const [leaderList, setLeaderList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [dataEditor, setdataEditor] = useState(null)

  useEffect(() => {
    ;(async () => {
      await selectPeopleStore.clearSelectUserData()
      await selectPeopleStore.clearSelected()
    })()
  }, [])

  const ratingDetailSelf = ratingDetails.details.find(
    e => e.evaluatorType === 'self'
  )

  const ratingDetailmanager = ratingDetails.details.find(
    e => e.evaluatorType === 'manager'
  )

  const ratingDetailsByevaluatorType =
    ratingDetails.details.find(e => e.evaluatorType === evaluatorType) || {}

  useEffect(() => {
    setLeaderList([
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
    ])
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const filterUserAssignees = useMemo(
    () =>
      ratingDetails?.assignees?.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      ),
    [ratingDetails]
  )

  const filterDepartmentAssignees = useMemo(
    () =>
      ratingDetails?.assignees?.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      ),
    [ratingDetails]
  )

  const filterCompanyAssignees = useMemo(
    () =>
      ratingDetails?.assignees?.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.GROUP &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      ),
    [ratingDetails]
  )

  useEffect(() => {
    if (
      selectUserData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.LEADER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(filterUserAssignees)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.LEADER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(filterDepartmentAssignees)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.COMBINER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.LEADER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(filterCompanyAssignees)
      )
    }
  }, [originDepartmentWithUserList, open, ratingDetails])

  useEffect(() => {
    if (ratingDetails) {
      form.setFieldsValue({
        title: ratingDetails?.title,
      })
    }
    if (ratingDetails?.details) {
      if (ratingDetailsByevaluatorType) {
        form.setFieldsValue({
          discipline_score:
            ratingDetailsByevaluatorType.disciplineScore ||
            evaluatorType === 'self'
              ? ratingDetailSelf?.disciplineScore
              : evaluatorType === 'manager'
              ? ratingDetailSelf?.disciplineScore
              : evaluatorType === 'office'
              ? null
              : ratingDetailmanager?.disciplineScore,
          skill_score:
            ratingDetailsByevaluatorType.skillScore || evaluatorType === 'self'
              ? ratingDetailSelf?.skillScore
              : evaluatorType === 'manager'
              ? ratingDetailSelf?.skillScore
              : evaluatorType === 'office'
              ? null
              : ratingDetailmanager?.skillScore,
          performance_score:
            ratingDetailsByevaluatorType.performanceScore ||
            evaluatorType === 'manager'
              ? ratingDetailSelf?.performanceScore
              : ratingDetailmanager?.performanceScore,
          bonus_score:
            ratingDetailsByevaluatorType.bonusScore ||
            evaluatorType === 'manager'
              ? ratingDetailSelf?.bonusScore
              : ratingDetailmanager?.bonusScore,
          total_score:
            ratingDetailsByevaluatorType.totalScore ||
            evaluatorType === 'manager'
              ? ratingDetailSelf?.totalScore
              : ratingDetailmanager?.totalScore,
          bonus_reason: ratingDetailsByevaluatorType.bonusReason,
          bonus_amount: ratingDetailsByevaluatorType.bonusAmount,
          article_count: ratingDetailsByevaluatorType.articleCount,
          file_count: ratingDetailsByevaluatorType.fileCount,
          district_articles: ratingDetailsByevaluatorType.districtArticles,
          english_articles: ratingDetailsByevaluatorType.englishArticles,
          journalism_economics:
            ratingDetailsByevaluatorType.journalismEconomics,
          published_count: ratingDetailsByevaluatorType.publishedCount,
          debt_collection_rate: ratingDetailsByevaluatorType.debtCollectionRate,
          classification: ratingDetailsByevaluatorType.comments,
          minus_points: ratingDetailsByevaluatorType.minusPoints,
        })
        setdataEditor(ratingDetailsByevaluatorType.selfEvaluation)
      }
    }
  }, [ratingDetails, evaluatorType, form])

  const onValuesChange = (_, allValues) => {
    const fields = [
      'discipline_score',
      'skill_score',
      'performance_score',
      'bonus_score',
    ]

    const total = fields.reduce((sum, field) => {
      const value = parseFloat(allValues[field]) || 0
      return sum + value
    }, 0)

    form.setFieldsValue({ total_score: total.toString() })
  }

  const updateAssignees = useCallback(async () => {
    try {
      const dataSubmit = {
        new_items: [],
        remove_items: [],
      }
      loadingAnimationStore.setTableLoading(false)
      await updateAssignUser(code, dataSubmit)
      await selectPeopleStore.clearSelectUserData()
      await selectPeopleStore.clearSelected()
      await getRatingDetails(code)
      loadingAnimationStore.setTableLoading(false)
    } catch (error) {
      console.error('Error update assign user:', error)
    }
  }, [code, updateAssignUser])

  const onFinish = useCallback(
    async values => {
      const {
        title,
        discipline_score,
        skill_score,
        performance_score,
        bonus_score,
        total_score,
        bonus_reason,
        bonus_amount,
        article_count,
        file_count,
        district_articles,
        english_articles,
        journalism_economics,
        published_count,
        debt_collection_rate,
        selfEvaluation,
        classification,
        minus_points,
      } = values

      const new_items_assign = []
      const remove_items_assign = []
      const listAssignOrigin = [
        ...filterUserAssignees,
        ...filterDepartmentAssignees,
      ].map(el => ({
        assignee_code: el.assignee_code,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))

      const listAssignAfter = [
        ...leaderList,
        ...handlerList,
        ...combinerList,
      ].map(el => ({
        assignee_code: el.id,
        assignee_type: el.assignee_type,
        permission: el.permission,
      }))

      listAssignAfter.forEach(assignAfter => {
        if (
          !listAssignOrigin.some(
            assignOrigin =>
              assignOrigin.assignee_code + assignOrigin.permission ===
              assignAfter.assignee_code + assignAfter.permission
          )
        ) {
          new_items_assign.push({
            assignee_code: assignAfter.assignee_code,
            assignee_type: assignAfter.assignee_type,
            permission: assignAfter.permission,
          })
        }
      })

      listAssignOrigin.forEach(assignOrigin => {
        if (
          !listAssignAfter.some(
            assignAfter =>
              assignAfter.assignee_code + assignAfter.permission ===
              assignOrigin.assignee_code + assignOrigin.permission
          )
        ) {
          remove_items_assign.push({
            assignee_code: assignOrigin.assignee_code,
            assignee_type: assignOrigin.assignee_type,
            permission: assignOrigin.permission,
          })
        }
      })

      const dataSubmit = {
        new_items: new_items_assign,
        remove_items: remove_items_assign,
      }

      const statusMap = {
        self: 'PENDING',
        manager: 'TRUONG_BAN_APPROVED',
        office: 'VP_APPROVED',
        editor: 'BBT_APPROVED',
      }

      const status = statusMap[evaluatorType]

      const submitValues = {
        title: title,
        status: status,
      }

      try {
        loadingAnimationStore.setTableLoading(true)

        const submitDataUpdate = {
          disciplineScore: discipline_score,
          skillScore: skill_score,
          performanceScore: performance_score,
          bonusScore: bonus_score,
          totalScore: total_score && total_score === 0 ? null : total_score,
          bonusReason: bonus_reason,
          bonusAmount: bonus_amount,
          articleCount: article_count,
          fileCount: file_count,
          districtArticles: district_articles,
          englishArticles: english_articles,
          journalismEconomics: journalism_economics,
          publishedCount: published_count,
          debtCollectionRate: debt_collection_rate,
          selfEvaluation: EDITOR_REF?.current?.editor.getData(),
          comments: classification,
          minusPoints: minus_points,
        }

        // Call the API to update the rating
        // await updateRating(code, submitValues)
        await updateAssignUser(code, dataSubmit)
        await updateEvaluationDetail(code, evaluatorType, submitDataUpdate)
        await updateStatus(code, submitValues)
        message.success(
          `${
            evaluatorType === 'self'
              ? 'Cá nhân'
              : evaluatorType === 'manager'
              ? 'Trưởng phòng/ban'
              : evaluatorType === 'office'
              ? 'Văn phòng'
              : 'Ban biên tập'
          } đánh giá thành công`
        )
        await getRatingDetails(code)
        await selectPeopleStore.clearSelectUserData()
        await selectPeopleStore.clearSelected()
        setOpen(false)
      } catch (error) {
        console.error('Đã có lỗi xảy ra:', error)
      } finally {
        loadingAnimationStore.setTableLoading(false)
      }
    },
    [
      code,
      evaluatorType,
      filterUserAssignees,
      filterDepartmentAssignees,
      leaderList,
      handlerList,
      combinerList,
      EDITOR_REF,
      updateAssignUser,
      updateEvaluationDetail,
      updateStatus,
      selectPeopleStore,
      getRatingDetails,
      loadingAnimationStore,
    ]
  )

  useEffect(() => {
    ;(async () => {
      try {
        await updateAssignees()
      } catch (error) {
        console.error('onFinish error:', error)
      }
    })()
  }, [])

  const columns = [
    {
      title: 'TT',
      dataIndex: 'key',
      width: 50,
      align: 'center',
    },
    {
      title: 'Nội dung tiêu chí chấm điểm',
      dataIndex: 'content',
      width: 300,
      render: (text, record) => {
        return record.key === '5' ? <strong>{text}</strong> : text
      },
    },
    {
      title: 'Điểm tối đa',
      dataIndex: 'maxPoints',
      width: 100,
      align: 'center',
      render: (value, record, index) => {
        // Chỉ hiển thị "Điểm tối đa" cho 5 hàng đầu tiên
        if (index >= 5) {
          return {
            children: null,
            props: { colSpan: 0 }, // Ẩn cột "Điểm tối đa" từ hàng thứ 6
          }
        }
        return record.key === '5' ? <strong>{value}</strong> : value
      },
    },
    {
      title: `${
        evaluatorType === 'self'
          ? 'Cá nhân tự đánh giá'
          : evaluatorType === 'manager'
          ? 'Trưởng phòng/ban đánh giá'
          : evaluatorType === 'office'
          ? 'Văn phòng đánh giá'
          : 'Ban biên tập đánh giá'
      }`,
      align: 'center',
      dataIndex: 'selfEvaluation',
      width: 200,
      render: (_, record, index) => {
        if (index >= 5) {
          return {
            children: (
              <Form.Item name={record.label} style={{ margin: 0 }}>
                <Input
                  placeholder={`Nhập ${record.content.toLowerCase()}`}
                  style={{
                    width: '100%',
                  }}
                />
              </Form.Item>
            ),
            props: { colSpan: 2 },
          }
        }

        if (index === 4) {
          // Trường tổng điểm
          return (
            <Form.Item name={record.label} style={{ margin: 0 }}>
              <Input
                readOnly
                style={{
                  width: '100%',
                  backgroundColor: '#f5f5f5',
                  fontWeight: 'bold',
                }}
              />
            </Form.Item>
          )
        }

        // Các trường nhập điểm
        return (
          <Form.Item
            name={record.label}
            style={{ margin: 0 }}
            rules={[
              {
                type: 'number',
                transform: value => Number(value),
                min: 0,
                max: record.maxPoints,
                message: `Điểm phải nằm trong khoảng từ 0 đến ${record.maxPoints}`,
              },
            ]}>
            <Input
              type="number"
              style={{ width: '100%' }}
              min={0}
              max={record.maxPoints}
            />
          </Form.Item>
        )
      },
    },
  ]

  const data = [
    {
      key: '1',
      label: 'discipline_score',
      content: 'Ý thức tổ chức kỷ luật',
      maxPoints: 20,
      selfEvaluation: ratingDetailsByevaluatorType.disciplineScore || '-',
    },
    {
      key: '2',
      label: 'skill_score',
      content: 'Năng lực, Kỹ năng',
      maxPoints: 20,
      selfEvaluation: ratingDetailsByevaluatorType.skillScore || '-',
    },
    {
      key: '3',
      label: 'performance_score',
      content: 'Kết quả thực hiện nhiệm vụ được giao',
      maxPoints: 50,
      selfEvaluation: ratingDetailsByevaluatorType.performanceScore || '-',
    },
    {
      key: '4',
      label: 'bonus_score',
      content: 'Điểm thưởng',
      maxPoints: 10,
      selfEvaluation: ratingDetailsByevaluatorType.bonusScore || '-',
    },
    {
      key: '5',
      label: 'total_score',
      content: 'Cộng điểm',
      maxPoints: 100,
      selfEvaluation: ratingDetailsByevaluatorType.totalScore || '-',
    },
    {
      key: '6',
      label: 'bonus_reason',
      content: 'Lý do thưởng',
      selfEvaluation: ratingDetailsByevaluatorType.bonusReason || '-',
    },
    {
      key: '7',
      label: 'bonus_amount',
      content: 'Nhuận bút (đồng)',
      selfEvaluation: ratingDetailsByevaluatorType.bonusAmount || '-',
    },
    {
      key: '8',
      label: 'article_count',
      content: 'Số lượng tin, bài',
      selfEvaluation: ratingDetailsByevaluatorType.articleCount || '-',
    },
    {
      key: '9',
      label: 'file_count',
      content: 'Số đề tài/ Phóng sự',
      selfEvaluation: ratingDetailsByevaluatorType.fileCount || '-',
    },
    {
      key: '10',
      label: 'district_articles',
      content: 'Bài viết về quận, huyện, ngành theo dõi',
      selfEvaluation: ratingDetailsByevaluatorType.districtArticles || '-',
    },
    {
      key: '11',
      label: 'english_articles',
      content: 'Bài viết chuyên sâu bằng tiếng Anh(PV.HNT)',
      selfEvaluation: ratingDetailsByevaluatorType.englishArticles || '-',
    },
    {
      key: '12',
      label: 'journalism_economics',
      content: 'Kinh tế báo chí + Đạt %',
      selfEvaluation: ratingDetailsByevaluatorType.journalismEconomics || '-',
    },
    {
      key: '13',
      label: 'published_count',
      content: 'Số lượng báo phát hành',
      selfEvaluation: ratingDetailsByevaluatorType.publishedCount || '-',
    },
    {
      key: '14',
      label: 'debt_collection_rate',
      content: 'Tỷ lệ thu hồi công nợ',
      selfEvaluation: ratingDetailsByevaluatorType.debtCollectionRate || '-',
    },
  ]

  return (
    <>
      <Modal
        width={800}
        visible={open}
        onCancel={() => setOpen(false)}
        title={`${
          evaluatorType === 'self'
            ? 'Cá nhân '
            : evaluatorType === 'manager'
            ? 'Trưởng phòng/ban '
            : evaluatorType === 'office'
            ? 'Văn phòng '
            : 'Ban biên tập '
        } đánh giá`}
        style={{ top: 5 }}
        maskClosable={false}
        footer={null}>
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          onValuesChange={onValuesChange}
          style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Form.Item
            label="Tiêu đề"
            name="title"
            rules={[{ required: true, message: 'Vui lòng nhập tiêu đề!' }]}>
            <Input placeholder="Nhập tiêu đề" />
          </Form.Item>

          {!(evaluatorType === 'office') && (
            <Table
              columns={columns}
              dataSource={data}
              pagination={false}
              bordered
              size="middle"
              scroll={{ x: 'max-content' }}
            />
          )}

          <Form.Item
            label={
              evaluatorType === 'self'
                ? 'Tự đánh giá các việc đã làm được và những hạn chế chưa làm được'
                : evaluatorType === 'manager'
                ? 'Trưởng phòng đánh giá'
                : evaluatorType === 'office'
                ? 'Văn phòng đánh giá'
                : 'Ban biên tập đánh giá'
            }
            name="selfEvaluation"
            style={{ marginTop: '10px' }}>
            <RichEditor
              EDITOR_REF={EDITOR_REF}
              editorContent={ratingDetailsByevaluatorType.selfEvaluation}
              height={300}
            />
          </Form.Item>

          {evaluatorType === 'office' && (
            <>
              <Form.Item
                label="Số điểm đánh giá"
                name="discipline_score"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng nhập số điểm đánh giá!',
                  },
                  {
                    type: 'number',
                    transform: value => Number(value),
                    max: 100,
                    message: `Điểm không được vượt quá 100`,
                  },
                ]}
                style={{ marginTop: '10px' }}>
                <Input
                  type="number"
                  placeholder="Số điểm đánh giá"
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item
                label="Số điểm bị trừ nếu có"
                name="skill_score"
                rules={[
                  {
                    type: 'number',
                    transform: value => Number(value),
                    max: 100,
                    message: `Điểm không được vượt quá 100`,
                  },
                ]}
                style={{ marginTop: '10px' }}>
                <Input
                  type="number"
                  placeholder="Số điểm đánh giá"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </>
          )}

          {/* Radio group for classification */}
          {!(evaluatorType === 'office') && (
            <Form.Item
              label={
                evaluatorType === 'self'
                  ? 'Tự xếp loại'
                  : evaluatorType === 'manager'
                  ? 'Trưởng phòng xếp loại'
                  : evaluatorType === 'office'
                  ? 'Số điểm đánh giá: '
                  : 'Ban biên tập xếp loại'
              }
              name="classification"
              rules={[{ required: true, message: 'Vui lòng chọn xếp loại!' }]}>
              <Radio.Group
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px', // khoảng cách giữa các Radio
                }}>
                <Radio
                  value="excellent"
                  style={{
                    padding: '8px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    backgroundColor: '#fafafa',
                    color: 'red',
                  }}>
                  Xuất sắc (Từ 90 đến 100 điểm)
                </Radio>
                <Radio
                  value="good"
                  style={{
                    padding: '8px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    backgroundColor: '#fafafa',
                    color: 'blue',
                  }}>
                  Tốt (Từ 70 đến 89 điểm)
                </Radio>
                <Radio
                  value="completed"
                  style={{
                    padding: '8px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    backgroundColor: '#fafafa',
                  }}>
                  Hoàn thành (Từ 50 đến dưới 69 điểm)
                </Radio>
                <Radio
                  value="notCompleted"
                  style={{
                    padding: '8px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    backgroundColor: '#fafafa',
                  }}>
                  Không hoàn thành (Dưới 50 điểm)
                </Radio>
              </Radio.Group>
            </Form.Item>
          )}

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                <span style={{ color: redPrimary, marginRight: 4 }}>*</span>{' '}
                Trưởng phòng/ban:
              </label>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.LEADER)
                    }
                  />
                </Tooltip>
              </Space>
              <SelectList>
                {leaderList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
            {/* <Col span={8}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                <span style={{ color: redPrimary, marginRight: 4 }}>*</span>Văn
                phòng:
              </label>

              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(
                        ASSIGNEE_TYPE.COMBINER
                      )
                    }
                  />
                </Tooltip>
              </Space>

              <SelectList>
                {combinerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col> */}
            <Col span={12}>
              <label
                style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
                <span style={{ color: redPrimary, marginRight: 4 }}>*</span>Ban
                biên tập:
              </label>

              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={() =>
                      handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
                    }
                  />
                </Tooltip>
              </Space>

              <SelectList>
                {handlerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
          </Row>

          <Form.Item
            style={{
              margin: 0,
              width: '100%',
              marginTop: '15px',
            }}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button
                danger
                icon={<CloseOutlined />}
                onClick={() => setOpen(false)}>
                Hủy bỏ
              </Button>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '-30px',
              }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginLeft: '10px' }}>
                Cập nhật
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        departmentType={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.LEADER
            ? currentUser?.department?.code
            : selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.COMBINER
            ? 'DPT182746500449800'
            : 'DPT10362627906695166'
        }
      />
    </>
  )
}

export default inject(
  'internalAssessmentStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'authenticationStore'
)(observer(InternalAssessmentUpdate))
